import { lazy, Suspense } from 'react';
import { PageLoader } from '../../utils/lazyComponents';

/**
 * A higher-order component for lazy loading with Suspense
 * @param {Function} importFunc - Function that returns a dynamic import()
 * @returns {React.Component} - A component that handles the lazy loading
 */
export const Loadable = (importFunc) => {
  const LazyComponent = lazy(importFunc);
  
  return function LoadableComponent(props) {
    return (
      <Suspense fallback={<PageLoader />}>
        <LazyComponent {...props} />
      </Suspense>
    );
  };
};

export default Loadable;
